import {useEffect, useState} from 'react'

import {
  requestEarliestEnglishSlotViaEmbed,
  type EarliestEnglishSlotInput,
  type EarliestEnglishSlotResult,
} from '@progyny/utils/calcom'

const EMPTY_RESULT: EarliestEnglishSlotResult = {
  earliestEnglishSlot: null,
  earliestSelectedLanguageSlot: null,
}

export function useEarliestSlotForLanguage(
  input: EarliestEnglishSlotInput | null
) {
  const [result, setResult] = useState<EarliestEnglishSlotResult>(EMPTY_RESULT)

  useEffect(() => {
    setResult(EMPTY_RESULT)

    if (!input || input.language === 'en') {
      return
    }

    const controller = new AbortController()

    requestEarliestEnglishSlotViaEmbed(input, controller.signal).then(setResult)

    return () => controller.abort()
  }, [input])

  return result
}
